import { useMemo } from "react";
import { cashnator, formatarData } from "../utils/functions";
import SimpleTable from "../table/SimpleTable";

const TransactionsList = ({ transactions, setEdit, setEditableTransaction }) => {
    const columns = useMemo(() => [
        { key: "product._id", header: "ID Pedido", width: 220 },
        { key: "product.finalPrice", header: "Valor", width: 110, format: (value) => cashnator(value) },
        { key: "user.email", header: "Usuário", width: 220 },
        { key: "data.status", header: "Status", width: 120 },
        { key: "data.received_at", header: "Data", width: 110, format: (value) => formatarData(value) },
        {
            key: "ver", header: "", width: 70, sortable: false, hideable: false, exportable: false,
            cell: ({ row }) => <button type="button" onClick={() => { setEdit(true); setEditableTransaction(row); }} className="bg-blue-500 px-2 text-black hover:bg-blue-800">Ver</button>,
        },
    ], [setEdit, setEditableTransaction]);
    return <SimpleTable tableKey="admin-transactions" columns={columns} data={transactions} />;
};

export default TransactionsList;
